import { createPinia } from 'pinia';
import { setPiniaPlugins } from '@/presentation/store/plugins.js';

const pinia = createPinia();

setPiniaPlugins(pinia);

export const resetAllStores = () => {
	pinia._s.forEach((store) => {
		if (store.resetStore) return store.resetStore();
		store.$reset();
	});
};

export default pinia;
